<div mat-dialog-title>

  <h1 class="titulo-simpli">Certificado Digital</h1>
  <small class="subtitulo-simpli">Cambia o actualiza tu Certificado Digital</small>

  <div class="btn_cerrar" [mat-dialog-close]="guardado" [class.btn_cerrar--off]="paso == 'guardando' || paso == 'verificando'">

    <span class="material-symbols-outlined">close</span>

  </div>

</div>

<div mat-dialog-content>
  <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
    <mat-card class="animate__animated animate__fadeIn" style="border: none;box-shadow: none !important;">

      <mat-card-content>

        @if (paso == 'formulario' || paso == 'guardando') {
        <form  [formGroup]="valForm">

          <div class="row">


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

              <mat-form-field color="primary" appearance="fill">
                <mat-label>Adjuntar Certificado</mat-label>
                <input required matInput formControlName="certificado_sii" readonly (click)="open_certificado()" >
                <input id="certificado_pfx" (change)="subir_certificado_new($event)" type="file" accept=".pfx"  style="display: none;">
                @if (saving_certificado) {
                  <mat-spinner color="primary" diameter="20" matSuffix></mat-spinner>
                }
                @if (success_certificado) {
                  <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color:#3BA46F;">check_circle</mat-icon>
                }
                @if (!success_certificado) {
                  <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color: var(--simpli-primary);">attach_file</mat-icon>
                }
                <mat-hint> Solo se admite el formato PFX y un peso límite de 50 MB</mat-hint>
                @if (valForm.controls['certificado_sii'].hasError('incorrect')) {
                  <mat-error>
                    {{message_pfx}}
                  </mat-error>
                }
              </mat-form-field>


              <mat-form-field color="primary" appearance="fill">
                <mat-label>Clave Certificado</mat-label>
                <input required matInput formControlName="clave_certificado" type="password" autocomplete="new-password" (input)="subir_clave_pfx($event)" >
                @if (saving_clave) {
                  <mat-spinner color="primary" diameter="20" matSuffix></mat-spinner>
                }
                @if (success_clave) {
                  <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color:#3BA46F;">check_circle</mat-icon>
                }
                <mat-hint>Por seguridad no mostramos la clave guardada: escríbela de nuevo.</mat-hint>
                @if (valForm.controls['clave_certificado'].hasError('incorrect')) {
                  <mat-error>
                    {{ message_clave }}
                  </mat-error>
                }
              </mat-form-field>


              @if (mostrar_rut) {
                <mat-form-field color="primary" appearance="fill">
                  <mat-label>RUT del titular del certificado</mat-label>
                  <input matInput formControlName="rut_autorizado" (change)="subir_rut_autorizado($event)" >
                  @if (success_rut && !valForm.controls['rut_autorizado'].hasError('incorrect')) {
                    <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color:#3BA46F;">check_circle</mat-icon>
                  }
                  <mat-hint>Por ejemplo 12345678-9</mat-hint>
                  @if (valForm.controls['rut_autorizado'].hasError('incorrect')) {
                    <mat-error>{{ message_rut }}</mat-error>
                  }
                </mat-form-field>
                @if (aviso_rut) {
                  <div class="warning-msg cert-aviso">
                    <span class="material-symbols-outlined">badge</span>
                    <div>{{ aviso_rut }}</div>
                  </div>
                }
              } @else {
                <p class="cert-rut-auto">
                  <span class="material-symbols-outlined">badge</span>
                  <span>El RUT autorizado se toma de tu certificado.</span>
                </p>
              }

              @if (error_general) {
                <div class="error-msg cert-aviso">
                  <span class="material-symbols-outlined">error</span>
                  <div>{{ error_general }}</div>
                </div>
              }

              <div class="leyenda">

                Su clave y certificado están protegidos con altos estándares de seguridad y encriptación. Al continuar, confirma que acepta nuestra
                <a class="simpli-color2 cursor-pointer text-none" href="https://simplilatam.com/politica-de-privacidad/" target="_blank">política de privacidad</a>
                diseñada para resguardar su información en todo momento.

              </div>

            </div>







          </div>



        </form>
        } @else {
          <div class="cert-resultado">
            @if (paso == 'verificando') {
              <div class="cert-verificando">
                <span class="material-symbols-outlined mat-spin">progress_activity</span>
                <div>
                  <b>Guardamos tu certificado. Lo estamos verificando en el SII…</b>
                  <small>Puede tardar unos segundos. No cierres esta ventana.</small>
                </div>
              </div>
            }
            @if (paso == 'resultado' && resultado) {
              <div class="cert-aviso" [ngClass]="resultado.clase">
                <span class="material-symbols-outlined">{{ resultado.icono }}</span>
                <div>
                  <b>{{ resultado.titulo }}</b>
                  <p>{{ resultado.mensaje }}</p>
                  @if (resultado.permisos) {
                    <p class="cert-permisos">
                      <span>Permisos de tu RUT en el SII:</span>
                      <span [ngClass]="resultado.permisos.firmar ? 'estado-ok' : 'estado-error'">
                        <span class="material-symbols-outlined">{{ resultado.permisos.firmar ? 'check_circle' : 'cancel' }}</span>Firmar documentos
                      </span>
                      <span [ngClass]="resultado.permisos.enviar ? 'estado-ok' : 'estado-error'">
                        <span class="material-symbols-outlined">{{ resultado.permisos.enviar ? 'check_circle' : 'cancel' }}</span>Enviar documentos
                      </span>
                    </p>
                  }
                </div>
              </div>
            }
            @if (paso == 'resultado' && !resultado) {
              <div class="info-msg cert-aviso">
                <span class="material-symbols-outlined">info</span>
                <div>{{ sin_verificar }}</div>
              </div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      @if (paso == 'resultado') {
        <div class="btn-simpli-container">
          <button class="primary-button" mat-flat-button (click)="update()">Listo</button>
        </div>
      } @else if (paso != 'verificando') {
      <div [ngClass]="{'disable-btn':desactivar_guardar == true, 'btn-simpli-container':true}">
        <button [disabled]="desactivar_guardar" class="primary-button" mat-flat-button (click)="put_certificado()">
          @if (paso == 'formulario') {
            <mat-label>Guardar</mat-label>
          }
          @if (paso == 'guardando') {
            <span><span class="material-symbols-outlined mat-spin" style="color:white;">progress_activity</span></span>
          }
        </button>
      </div>
      }

    </div>
  </div>
</div>

